import type { Translations } from '../keys';

const deDE: Translations = {
  'common.search': 'Suchen',
  'common.copied': 'Kopiert',
  'common.copy': 'Kopieren',
  'common.poweredBy': 'Powered by',
  'common.plan': 'Plan',
  'common.banner': 'Banner',
  'common.total': 'Gesamt {value}',
  'common.installmentPrefix': '{count}x à',
  'common.discountCoupon': 'Rabattcode',
  'common.checkout': 'Kasse',
  'common.tryAgain': 'Erneut versuchen',

  'app.loading': 'Kasse wird geladen …',
  'app.init.error': 'Fehler beim Initialisieren der Kasse:',

  'checkout.title': 'Abonnement abschließen',
  'checkout.subtitle': 'Gib deine Daten ein, um Zugang zu {productName} zu erhalten.',
  'checkout.greeting': 'Schön, dass du da bist, {firstName}',
  'checkout.contactInfo': 'Kontaktdaten',
  'checkout.contact.namePlaceholder': 'Vollständiger Name',
  'checkout.paymentMethod': 'Zahlungsmethode',
  'checkout.cardData': 'Kartendaten',
  'checkout.card.maskPlaceholder': '•••• •••• •••• ••••',
  'checkout.card.expMonth': 'Monat',
  'checkout.card.expYear': 'Jahr',
  'checkout.card.cvv': 'CVV',
  'checkout.card.expiryPlaceholder': 'MM/JJ',
  'checkout.card.holderName': 'Vollständiger Name des Karteninhabers',
  'checkout.document': 'Ausweis',
  'checkout.document.cpfHolder': 'CPF des Karteninhabers',
  'checkout.useFilledName': 'Bereits eingegebenen Namen verwenden',
  'checkout.summary.ariaLabel': 'Zusammenfassung des Abonnements',
  'checkout.summary.community': 'Community',
  'checkout.summary.availablePlans': 'Verfügbare Pläne',
  'checkout.summary.chooseAccess': 'Zugang auswählen',
  'checkout.summary.buying': 'Du kaufst:',
  'checkout.summary.renewal': 'Verlängert sich am {date}. Du kannst jederzeit kündigen.',
  'checkout.theme.enableLight': 'Helles Design aktivieren',
  'checkout.theme.enableDark': 'Dunkles Design aktivieren',
  'checkout.theme.light': 'Hell',
  'checkout.theme.dark': 'Dunkel',
  'checkout.installments.title': 'Ratenzahlung',
  'checkout.installments.placeholder': 'Anzahl der Raten',
  'checkout.installments.discount': '{percent}% Rabatt',
  'checkout.submit.generatePix': 'PIX-Code generieren',
  'checkout.submit.buyLifetime': '{productName} kaufen (lebenslanger Zugriff)',
  'checkout.submit.subscribe': '{productName} abonnieren',
  'checkout.footer.safeTransaction': 'Sichere und verschlüsselte Transaktion',
  'checkout.footer.termsPrefix': 'Mit dem Bestätigen deines Kaufs stimmst du den',
  'checkout.footer.terms': 'Nutzungsbedingungen von Ginastee zu',

  'checkout.notFound.eyebrow': 'Kasse nicht verfügbar',
  'checkout.notFound.title': 'Community nicht gefunden',
  'checkout.notFound.description': 'Dieser Checkout-Link gehört zu keiner aktiven Community. Prüfe die Adresse oder kontaktiere die Community.',

  'checkout.paymentsUnavailable.message': 'Zahlungen für deine Region sind noch nicht verfügbar — der Community-Inhaber muss die Einrichtung seiner Wallet abschließen.',
  'checkout.paymentsUnavailable.action': 'Mehr erfahren',

  'coupon.title': 'Rabattcode',
  'coupon.placeholder': 'Rabattcode eingeben',
  'coupon.notFound': 'Rabattcode nicht gefunden',

  'pix.title': 'Zahlung mit PIX abschließen',
  'pix.instructions': 'Öffne eine App, in der du PIX aktiviert hast, wähle "Bezahlen" und dann "QR-Code scannen".',
  'pix.scanQrCode': 'Scanne den QR-Code unten in deiner Banking-App',
  'pix.qrAlt': 'PIX-QR-Code',
  'pix.copyCode': 'Oder kopiere den folgenden Code und füge ihn ein',
  'pix.timeLeft': 'Deine Zahlungsfrist endet in:',
  'pix.realtime': 'In Echtzeit aktualisiert',

  'thanks.confirming.title': 'Zahlung wird bestätigt',
  'thanks.confirming.description': 'Wir warten auf die Zahlungsbestätigung, bevor der Zugang freigeschaltet wird.',
  'thanks.failed.title': 'Zahlung nicht bestätigt',
  'thanks.failed.description': 'Wir konnten deine Zahlung nicht bestätigen. Versuche es erneut oder kontaktiere den Support.',
  'thanks.success.title': 'Herzlichen Glückwunsch!',
  'thanks.success.subtitle': 'Du hast {productName} abonniert',
  'thanks.success.emailSent': 'Wir haben dir eine E-Mail mit dem Zugangslink zur Plattform geschickt.',
  'thanks.success.emailMissing': 'Noch keine E-Mail erhalten?',
  'thanks.success.emailDelay': 'Die Registrierungs-E-Mail kommt in der Regel innerhalb von 5 Minuten an.',
  'thanks.success.spamSupport': 'Falls diese Zeit verstrichen ist, sieh im Spam-Ordner nach oder schreibe eine Nachricht an den Support-Kanal.',
  'thanks.success.supportButton': 'Die E-Mail ist noch nicht angekommen',

  'method.creditCard': 'Kreditkarte',
  'method.pix': 'PIX',

  'input.fullName.placeholder': 'Vollständigen Namen eingeben',
  'input.phone.placeholder': 'Handynummer',
  'input.country.searchPlaceholder': 'Land suchen',
  'input.date.label': 'Datum',
  'input.date.placeholder': 'TT.MM.JJJJ',
  'input.cpf.placeholder': '000.000.000-00',
  'input.money.label': 'Betrag',
  'input.money.placeholder': '0,00 €',
  'input.cnpj.label': 'Firmennummer',
  'input.cnpj.placeholder': '00.000.000/0000-00',
  'input.email.placeholder': 'email@beispiel.de',
  'input.cardNumber.label': 'Kartennummer',
  'input.cardNumber.placeholder': '0000 0000 0000 0000',

  'address.label': 'Adresse',
  'address.placeholder': 'Adresse suchen',
  'address.noOptions': 'Keine Adresse gefunden',
  'address.number.label': 'Nummer',
  'address.number.placeholder': 'Nr.',
  'address.complement.label': 'Adresszusatz',
  'address.complement.placeholder': 'Wohnung, Gebäude...',
  'address.neighborhood.label': 'Stadtteil',
  'address.zipcode.label': 'Postleitzahl',
  'address.zipcode.placeholder': '00000',
  'address.city.label': 'Stadt',
  'address.state.placeholder': 'Bundesland',

  'stripe.error.generic': 'Bei der Zahlung ist ein Fehler aufgetreten. Prüfe die eingegebenen Daten und versuche es erneut.',
  'stripe.error.incompleteCard': 'Fülle die Kartendaten aus, um fortzufahren',
  'stripe.error.confirmPayment': 'Bei der Bestätigung der Zahlung ist ein Fehler aufgetreten',
  'stripe.submit': 'Zahlung bestätigen',

  'payment.error.generic': 'Bei der Zahlung ist ein Fehler aufgetreten. Prüfe die eingegebenen Daten und versuche es erneut.',
  'payment.error.prepare': 'Bei der Vorbereitung der Zahlung ist ein Fehler aufgetreten. Prüfe die eingegebenen Daten und versuche es erneut.',
  'payment.error.missingCharge': 'Zahlungskennung wurde nicht zurückgegeben',
  'payment.error.notApproved': 'Zahlung nicht genehmigt. Prüfe deine Kartendaten und versuche es erneut.',

  'validation.cardNumber': 'Ungültige Kartennummer',
  'validation.cardExpiration': 'Ungültiges Ablaufdatum',
  'validation.cardExpired': 'Karte abgelaufen',
  'validation.cardCvv': 'Ungültiger CVV',
  'validation.cpf': 'Ungültiger CPF',
  'validation.fullName': 'Vollständiger Name ungültig',
  'validation.fullNameLettersOnly': 'Der Name darf nur Buchstaben enthalten',
  'validation.emailRequired': 'E-Mail ist erforderlich',
  'validation.emailInvalid': 'Ungültige E-Mail',
  'validation.phoneRequired': 'Telefonnummer ist erforderlich',
  'validation.phoneInvalid': 'Ungültige Telefonnummer',
  'validation.phoneDigits': 'Die Telefonnummer muss 10 oder 11 Ziffern haben',
  'validation.phoneMobileStartsWithNine': 'Die Handynummer muss mit 9 beginnen',
  'validation.phoneDdd': 'Ungültige Vorwahl',

  'interval.week.adjective': 'Wöchentlich',
  'interval.month.adjective': 'Monatlich',
  'interval.bimonthly.adjective': 'Zweimonatlich',
  'interval.quarterly.adjective': 'Vierteljährlich',
  'interval.semiannual.adjective': 'Halbjährlich',
  'interval.year.adjective': 'Jährlich',
  'interval.lifetime.adjective': 'Lebenslang',
  'interval.week.noun': 'Woche',
  'interval.month.noun': 'Monat',
  'interval.bimonthly.noun': 'Zwei Monate',
  'interval.quarterly.noun': 'Quartal',
  'interval.semiannual.noun': 'Halbjahr',
  'interval.year.noun': 'Jahr',
  'interval.lifetime.noun': 'Lebenslang',
  'interval.lifetime.access': 'lebenslanger Zugriff',
  'interval.period': 'Zeitraum',

  'month.01': 'Januar',
  'month.02': 'Februar',
  'month.03': 'März',
  'month.04': 'April',
  'month.05': 'Mai',
  'month.06': 'Juni',
  'month.07': 'Juli',
  'month.08': 'August',
  'month.09': 'September',
  'month.10Label': 'Oktober',
  'month.11Label': 'November',
  'month.12': 'Dezember',
};

export default deDE;
